module.exports = __webpack_public_path__ + "img/gold-card-with-logo.b226e275.png";